export default "__VITE_ASSET__CofzfYWn__"